export default __webpack_public_path__ + "static/media/patio.1fbfefc8.svg";